import React from 'react';
import { ActivityAssociation, File } from 'v2/models';
import CheckboxTooltip from 'v2/common/CheckBox/CheckboxTooltip';
import { useActivityAssociationLabel } from 'v2/hooks/useActivityAssociationLabel';

export interface ActivityAssociationCheckboxProps {
  association: ActivityAssociation;
  checkedAssociations: Array<ActivityAssociation>;
  file: File | undefined;
  activityType?: string;
  checkBoxChanged: (
    isChecked: boolean,
    association: ActivityAssociation
  ) => void;
}

const ActivityAssociationCheckbox = ({
  association,
  checkedAssociations,
  file,
  activityType,
  checkBoxChanged,
}: ActivityAssociationCheckboxProps) => {
  const key = `${association.table_name}_${association.object_id}`;
  const isSelected = checkedAssociations.some(
    (item) =>
      item.object_id === association.object_id &&
      item.table_name === association.table_name
  );

  const disabled =
    isSelected &&
    (checkedAssociations.length === 1 || association.is_mandatory);
  const entity = file
    ? file.name || 'The file'
    : activityType || 'The activity';
  const tooltip =
    checkedAssociations.length > 1
      ? 'This association can not be removed'
      : `${entity} must have at least one association`;
  const message = disabled ? tooltip : '';

  const label = useActivityAssociationLabel(association);

  return (
    <CheckboxTooltip
      key={key}
      keyText={key}
      checked={isSelected}
      label={label}
      disabled={disabled}
      tooltip={message}
      onChange={(elem) => checkBoxChanged(elem.target.checked, association)}
    />
  );
};

export default ActivityAssociationCheckbox;
